import { type RemoteApiHttpEndpoint } from "../../../../gql-generated/types";
import { type RemoteApiFormValues } from "../schema";

export const makeEndpointPrevew = (
    endpoint: RemoteApiFormValues["endpoints"][number] | RemoteApiHttpEndpoint | undefined,
    host = "",
): string => {
    const protocol = "https://";

    if (!endpoint) {
        return "";
    }

    const pathStr = endpoint.path ? `/${endpoint.path}` : "";

    const params = new URLSearchParams();
    const endpointParamerters = endpoint.parameters ?? [];
    for (const param of endpointParamerters) {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- need || for empty string
        params.append(param.name, param.defaultValue || `<${param.name}>`);
    }

    // decode special characters
    const paramsString = decodeURIComponent(params.toString());

    return params.size > 0 ? `${protocol}${host}${pathStr}?${paramsString}` : `${protocol}${host}${pathStr}`;
};
